import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddNewCategoryAction,showAddCategoryAction } from "../redux/actions/productsActions";
import * as LocalStorage from "../../utils/localStorage";
import { FaTimes } from "react-icons/fa";
import styles from "./productsStyles.module.css";

const AddNewCategory = () => {
  const actionDispatch = useDispatch();
  const { data, showAddCategory } = useSelector((state) => state.products);

  const closeAddCategory=()=>{
    if(showAddCategory){
        actionDispatch(showAddCategoryAction(false));
    }
  }
  const onAddNewCategory = (event) => {
    event.preventDefault();
    const { category } = event.target;
    const productCategories = data.categories;
    const categoryCheck=productCategories.filter((item)=>item.toLowerCase()===category.value.toLowerCase())
    if(categoryCheck.length===0){
      productCategories.push(category.value);
      LocalStorage.setLSValue("productsData", {
        ...data,
        categories: productCategories,
      });
      actionDispatch(
        AddNewCategoryAction(LocalStorage.getLSValue("productsData"))
      );
      actionDispatch(showAddCategoryAction(false));
    }
    else if(categoryCheck.length>0){
      alert(categoryCheck[0]+" is already present in product categories.")
    }
  };
  return (
    <div className={styles.addCategoryDiv}>
      <button className={styles.closeAddProduct} onClick={closeAddCategory}>
        <FaTimes />
      </button>
      <form onSubmit={onAddNewCategory} id={styles.addCategoryForm}>
        <label htmlFor={styles.addCategory}>Add Category</label>
        <input id={styles.addCategory} name="category" type="text" required></input>
        <button type="submit" className={styles.addCategoryBtn+" "+styles.productPageButtons}>Add Category</button>
      </form>
    </div>
  );
};

export default AddNewCategory;
